import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: `${theme.spacing(1)}px auto`,
    position: 'relative',
  },
  buttonProgress: {
    color: 'white',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const LoadingButton = ({ ...props }) => {
  const {
    loading,
    color,
    variant,
    disabled,
    onClick,
    text,
    className,
    name,
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Button
        data-cy={`loadingButton${name}`}
        color={color}
        variant={variant}
        disabled={disabled || loading}
        onClick={onClick}
        className={className}
      >
        {text}{' '}
      </Button>
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </div>
  );
};

LoadingButton.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
};

export default LoadingButton;
